"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
var DataGridWithSynchronousRowStore_1 = require("../datagrid/DataGridWithSynchronousRowStore");
exports.defaultDataGridProps = {
    leftMargin: 0,
    showHeaders: false,
    showRowBanding: false,
    showHorizontalGridLines: false,
};
// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
// and overrides from reactDataGrid.styl
var DataGridContainer = LayoutComponents_1.divWithStyle('headerlessDataGridContainer', {
    flex: 1,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    $nest: {
        '.tb-react-dg-hrow': {
            border: 'none'
        },
        '.tb-react-dg-hcell-resizable': {
            border: 'none'
        },
        '.tb-react-dg-hcol': {
            border: 'none !important'
        },
        '.tb-react-dg-bcell': {
            paddingLeft: 0,
            paddingRight: 0,
            $nest: {
                '&:focus': {
                    outline: 'none',
                },
            },
        },
    },
});
/**
 * A basic datagrid that does not show headers
 */
var HeaderlessDisplayGrid = /** @class */ (function (_super) {
    __extends(HeaderlessDisplayGrid, _super);
    function HeaderlessDisplayGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.handleGridErrors = function (_, gridErrors) {
            _this.setState({ gridErrors: gridErrors });
        };
        _this.state = {
            gridErrors: [],
        };
        return _this;
    }
    HeaderlessDisplayGrid.prototype.renderErrorUI = function () {
        return this.props.renderErrors(this.state.gridErrors);
    };
    HeaderlessDisplayGrid.prototype.render = function () {
        if (this.state.gridErrors && this.state.gridErrors.length > 0) {
            return this.renderErrorUI();
        }
        var dataGridProps = __assign({}, exports.defaultDataGridProps, { cols: this.props.columns, rowStore: this.props.rowStore, config: {
                colsPerChunk: this.props.columns.length,
                rowOuterHeight: this.props.rowHeight || VizPortalStyles_1.ListViewRowOuterHeight,
            }, showSpinnerWhileLoading: false, onError: this.handleGridErrors });
        return (React.createElement(DataGridContainer, null, this.props.rowCount === 0
            ? React.createElement("div", null, this.props.emptyGridMessage || Localize_1.Messages.EmptyContentMessage())
            : React.createElement(DataGridWithSynchronousRowStore_1.DataGridWithSynchronousRowStore, __assign({}, dataGridProps))));
    };
    return HeaderlessDisplayGrid;
}(React.PureComponent));
exports.HeaderlessDisplayGrid = HeaderlessDisplayGrid;
//# sourceMappingURL=HeaderlessDisplayGrid.js.map